module.exports = __webpack_public_path__ + "img/calendar.4f177350.svg";